import { LANGUAGE } from '../constants';
import Labels from '../constants/labels';

/** 
 * @name INITIAL_STATE
 * @constant 
 * @description
 * @type {Object}
 * @default
*/
const INITIAL_STATE = {
    ...Labels[ LANGUAGE ]
};

/**
 * **DO NOT** Manipulate the state directly, always apply to a new object first!! If you don't redux will not 
 * recognize a change in the data and the components will not receive the correct information.
 * 
 * @name reducer
 * @function
 * @description Handles reduction of data accross components for the piece of the site implied by the filename
 * @param {Object} state Current state of the data
 * @param {Object} action Information passed from the corresponding actions file
 */
const reducer = ( state = INITIAL_STATE, action ) => {
    
    /** 
     * Meta example case:
     *      case CONSTANTS[ whateverTheActionIs ]:
     *          return { ...state, key: action.payload.key }
     */
	switch( action.type ){
		default:
			return state;
    }
    
}

export default reducer;